// Approved brand roster (white "darkmode" logo variants), used sitewide.
export const BRAND_LOGOS = [
  { src: '/assets/brands/darkmode/cre8now_aok.webp', alt: 'CRE8NOW: AOK' },
  { src: '/assets/brands/darkmode/cre8now_audi.webp', alt: 'CRE8NOW: Audi' },
  { src: '/assets/brands/darkmode/cre8now_BBDO.webp', alt: 'CRE8NOW: BBDO' },
  { src: '/assets/brands/darkmode/cre8now_bcgdvwebp.webp', alt: 'CRE8NOW: BCG Digital Ventures' },
  { src: '/assets/brands/darkmode/cre8now_Cheil.webp', alt: 'CRE8NOW: Cheil Worldwide' },
  { src: '/assets/brands/darkmode/cre8now_deutschbank.webp', alt: 'CRE8NOW: Deutsche Bank' },
  { src: '/assets/brands/darkmode/cre8now_eurowings.webp', alt: 'CRE8NOW: Eurowings' },
  { src: '/assets/brands/darkmode/cre8now_fritzkola.webp', alt: 'CRE8NOW: fritz-kola' },
  { src: '/assets/brands/darkmode/cre8now_heycar.webp', alt: 'CRE8NOW: heycar' },
  { src: '/assets/brands/darkmode/cre8now_lared.webp', alt: 'CRE8NOW: La Red' },
  { src: '/assets/brands/darkmode/cre8now_lufthansa.webp', alt: 'CRE8NOW: Lufthansa' },
  { src: '/assets/brands/darkmode/cre8now_mindbox.webp', alt: 'CRE8NOW: Mindbox' },
  { src: '/assets/brands/darkmode/cre8now_pixum.webp', alt: 'CRE8NOW: Pixum' },
  { src: '/assets/brands/darkmode/cre8now_s&f.webp', alt: 'CRE8NOW: Scholz & Friends' },
  { src: '/assets/brands/darkmode/cre8now_Samsung.webp', alt: 'CRE8NOW: Samsung' },
  { src: '/assets/brands/darkmode/cre8now_sanmiguel.webp', alt: 'CRE8NOW: San Miguel' },
  { src: '/assets/brands/darkmode/cre8now_smart.webp', alt: 'CRE8NOW: smart' },
  { src: '/assets/brands/darkmode/cre8now_tomorrow-university.webp', alt: 'CRE8NOW: Tomorrow University' },
  { src: '/assets/brands/darkmode/cre8now_universal.webp', alt: 'CRE8NOW: Universal Music Group' }
];
